<template>
  <div >
        <router-view />
  </div>
</template>

<script>
export default {

created() {
  this.$store.dispatch('getDataWebsite')
  this.$store.dispatch('getBarItems')
  this.$store.dispatch('getStatus')
  this.$store.dispatch('getSection')
  this.$store.dispatch('getGaleiItem')
  this.$store.dispatch('getNews')
  this.$store.dispatch('getResult')   
  this.$store.dispatch('getCommune')
  this.$store.dispatch('getWilaya')
  this.$store.dispatch('getSettings')
  this.$store.dispatch('getItemBarNew')
  this.$store.dispatch('getUsersLabels')
}
}
</script>

<style> 
.v-application--is-ltr .v-textarea.v-text-field--enclosed .v-text-field__slot {
    margin-right: -37px !important;
}
@font-face {
     font-family: curve;
     src: url('./assets/font/learning_curve_regular_ot_ps.otf');
}

.enTet {
     font-family: curve;
     font-size: 29px;
     color: #fff !important;
     margin: 0;
     text-decoration: none
}
</style>